/**
 * The LinkNYC kiosk glyph: a tall cyan monolith with a dark display and a wifi
 * mark — a stylized take on what the sidewalk hubs actually look like. Authored
 * as an SVG, rasterized once into a sprite the IconLayer can place. The base of
 * the slab is the icon anchor, so each kiosk "stands" on its map coordinate.
 */

const W = 128;
const H = 160;

// viewBox 0 0 64 80, scaled 2x for crisp rasterization.
const SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" viewBox="0 0 64 80">
<defs><linearGradient id="b" x1="0" y1="0" x2="0" y2="1">
<stop offset="0" stop-color="#34ecf8"/><stop offset="1" stop-color="#10b6cf"/>
</linearGradient></defs>
<rect x="20" y="6" width="24" height="68" rx="6" fill="url(#b)" stroke="#04212e" stroke-width="2.5"/>
<rect x="24" y="12" width="16" height="42" rx="3" fill="#062430"/>
<g fill="none" stroke="#eafcff" stroke-width="2.4" stroke-linecap="round">
<path d="M25 33 a10 10 0 0 1 14 0"/><path d="M28 37 a6 6 0 0 1 8 0"/></g>
<circle cx="32" cy="41" r="2" fill="#eafcff"/>
<rect x="27" y="58" width="10" height="3" rx="1.5" fill="#062430"/>
</svg>`;

export interface KioskAtlas {
  url: string;
  mapping: Record<
    string,
    { x: number; y: number; width: number; height: number; anchorY: number; mask: boolean }
  >;
}

let atlas: KioskAtlas | null = null;
let started = false;

/**
 * Return the kiosk sprite atlas, rasterizing it on first call. Returns null
 * until the (async) raster completes — the renderer simply draws nothing for
 * those first frames, then picks the atlas up once ready.
 */
export function getKioskAtlas(): KioskAtlas | null {
  if (atlas) return atlas;
  if (!started) {
    started = true;
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = W;
      canvas.height = H;
      canvas.getContext('2d')!.drawImage(img, 0, 0, W, H);
      atlas = {
        url: canvas.toDataURL(),
        // anchorY at the slab's base so the kiosk stands on its coordinate.
        mapping: { kiosk: { x: 0, y: 0, width: W, height: H, anchorY: H, mask: false } },
      };
    };
    img.src = `data:image/svg+xml;base64,${btoa(SVG)}`;
  }
  return atlas;
}
